<template>
  <div class="right_box_main">
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" class="demo-form-inline" size="mini">
                <el-form-item prop="personName" label="姓名:">
                  <el-input
                    v-model="searchlist.personName"
                    placeholder="请输入姓名"
                    style="width:150px"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="personType" label="人员类型:" >
                   <el-select v-model="searchlist.personType" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期:">
                   <el-date-picker
                    v-model="searchlist.timer"
                    type="datetimerange"
                    format='yyyy-MM-dd HH:mm:ss'
                    value-format='yyyy-MM-dd HH:mm:ss'
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="idCard" label="身份证:">
                  <el-input
                    v-model="searchlist.idCard"
                    placeholder="请输入身份证"
                    style="width:150px"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
              </el-form>
              </div>
            <div class="table_card">
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f8fafa' }"
            border
            align="center"
            style="width: 100%"
          >
            <el-table-column type="index" align="center" label="序号" width="100"></el-table-column>
            <el-table-column prop="personName" align="center" label="姓名" width="150"></el-table-column>
            <el-table-column prop="personType" align="center" label="人员类型" width="150">
              <template scope="scope">
                    <span v-if='scope.row.personType == 0'>住户</span>
                    <span v-if='scope.row.personType == 1'>访客</span>
                    <span v-if='scope.row.personType == 2'>重点关注</span>
                  </template>
            </el-table-column>
            <el-table-column prop="intoTime" align="center" label="日期" width="220"></el-table-column>
            <el-table-column prop="idCard" align="center" label="身份证" width="180"></el-table-column>
            <el-table-column prop="ipAddress" align="center"	label="地址"></el-table-column>
            <el-table-column prop="bigImgurl" align="center" label="远景图">
              <template slot-scope="scope">
                    <img :src="scope.row.bigImgurl" alt style="width:50px;height:50px" />
              </template>
            </el-table-column>
            <el-table-column prop="smalImgurl" align="center" label="近景图">
              <template slot-scope="scope">
                    <img :src="scope.row.smalImgurl" alt style="width:50px;height:50px" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100">
              <!-- <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                      <button
                        class="iconfont icon-chakan tabBtn"
                        style="color:#199b5d"
                      ></button>
                    </el-tooltip> -->
            </el-table-column>
          </el-table>
          <el-pagination
                :page-size="pageConfig.pageSize"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                :total="pageConfig.total"
              ></el-pagination>
          </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      width="50%"
      >
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
// import { tabdata } from "@/mixins/tabledataMix.js";
export default {
  data() {
    return {
      dialogVisible: false,
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      searchlist: {
        personName: '',
        startIntoTime: '',
        endIntoTime: ''
      },
      tableData: [
      ],
      options: [{
          value: '0',
          label: '住户'
        }, {
          value: '1',
          label: '访客'
        }, {
          value: '2',
          label: '重点关注'
        }],
        value: ''
    };
  },
  methods: {
    //条件查询
    searchlistdata() {
      post("/admin/faceData/info/findList", {
              pageNo: 1,
              pageSize: 10,
              personName: this.searchlist.personName,
              personType: this.searchlist.personType,
              idCard: this.searchlist.idCard,
              // timer: this.searchlist.timer
              startIntoTime: this.searchlist.timer[0],
              endIntoTime: this.searchlist.timer[1]
            }).then(res => {
                console.log(res)
                this.tableData = res.content.list;
            });
    },
    searchlistReset() {
      this.searchlist = {};
      this.getFindvisionData();
    },
     getFindvisionData(){
         post("/admin/faceData/info/findList", {
              pageNo: this.pageConfig.pageNo,
              pageSize: this.pageConfig.pageSize,
            }).then(res => {
                console.log(res)
                this.tableData = res.content.list;
                this.pageConfig.total=res.content.count;
            });
      },
      //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getFindvisionData();
    },
  },
  mounted() {
    this.getFindvisionData();
  },
};
</script>
<style scoped>
</style>
